
import './surveyStats.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import user from '../../service/user';
import menuLayout from '../../directive/menu-layout';
import survey from '../../service/survey';

import pickerFilter from '../../filter/picker';

import routing from './surveyStats.routes';
import SurveyStatsController from './surveyStats.controller';
import storeDateSelector from '../../directive/store-date-selector';

export default angular.module('page.surveyStats', [
		uirouter,
		menuLayout,
		pickerFilter,
		survey,
		user,
		storeDateSelector,
		'chart.js'
	])
	.config(routing)
	.controller('SurveyStatsController', SurveyStatsController)
	.name;



// WEBPACK FOOTER //
// ./src/page/surveyStats/index.js